import { BaseProps } from "src/models/props";

export default function PublicRoute({ children }: BaseProps) {
  return (
    <div className="w-full h-screen flex justify-between flex-col">
      {children}
    </div>
  );
}
